import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildings_buildingIdCollectionPoints = z.any()
export type TagsGetBuildings_buildingIdCollectionPoints = z.infer<typeof tagsGetBuildings_buildingIdCollectionPoints>

export const paramsGetBuildings_buildingIdCollectionPoints = z.object({ "buildingId": z.string() })
export type ParamsGetBuildings_buildingIdCollectionPoints = z.infer<typeof paramsGetBuildings_buildingIdCollectionPoints>

export const responseGetBuildings_buildingIdCollectionPoints = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "type": z.enum(["electricity","gas","water","coal","heat","other"]), "customType": z.string().optional(), "identifier": z.string(), "supplier": z.string(), "price": z.string(), "singleRateTariff": z.boolean().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "meterCodes": z.array(z.string()).optional(), "consumptionReminderEnabled": z.boolean().optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildings_buildingIdCollectionPoints = z.infer<typeof responseGetBuildings_buildingIdCollectionPoints>

interface IGetBuildings_buildingIdCollectionPoints extends BaseMethodType {
  tags: TagsGetBuildings_buildingIdCollectionPoints,
  params: ParamsGetBuildings_buildingIdCollectionPoints,
  response: ResponseGetBuildings_buildingIdCollectionPoints
}
export const tagsPostBuildings_buildingIdCollectionPoints = z.any()
export type TagsPostBuildings_buildingIdCollectionPoints = z.infer<typeof tagsPostBuildings_buildingIdCollectionPoints>

export const paramsPostBuildings_buildingIdCollectionPoints = z.object({ "buildingId": z.string() })
export type ParamsPostBuildings_buildingIdCollectionPoints = z.infer<typeof paramsPostBuildings_buildingIdCollectionPoints>

export const bodyPostBuildings_buildingIdCollectionPoints = z.object({ "name": z.string().min(3), "type": z.enum(["electricity","gas","water","coal","heat","other"]), "customType": z.string().optional(), "identifier": z.string().min(3), "supplier": z.string().optional(), "price": z.string().optional(), "singleRateTariff": z.boolean().optional(), "meterCodes": z.array(z.string()).optional(), "consumptionReminderEnabled": z.boolean().optional() })
export type BodyPostBuildings_buildingIdCollectionPoints = z.infer<typeof bodyPostBuildings_buildingIdCollectionPoints>

export const responsePostBuildings_buildingIdCollectionPoints = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "type": z.enum(["electricity","gas","water","coal","heat","other"]), "customType": z.string().optional(), "identifier": z.string(), "supplier": z.string(), "price": z.string(), "singleRateTariff": z.boolean().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "meterCodes": z.array(z.string()).optional(), "consumptionReminderEnabled": z.boolean().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostBuildings_buildingIdCollectionPoints = z.infer<typeof responsePostBuildings_buildingIdCollectionPoints>

interface IPostBuildings_buildingIdCollectionPoints extends BaseMethodType {
  tags: TagsPostBuildings_buildingIdCollectionPoints,
  params: ParamsPostBuildings_buildingIdCollectionPoints,
  body: BodyPostBuildings_buildingIdCollectionPoints,
  response: ResponsePostBuildings_buildingIdCollectionPoints
}
export const URL = '/buildings/:buildingId/collectionPoints'
export const validation = {
  get: {
    tags: tagsGetBuildings_buildingIdCollectionPoints,
    params: paramsGetBuildings_buildingIdCollectionPoints,
    response: responseGetBuildings_buildingIdCollectionPoints
  },
  post: {
    tags: tagsPostBuildings_buildingIdCollectionPoints,
    params: paramsPostBuildings_buildingIdCollectionPoints,
    body: bodyPostBuildings_buildingIdCollectionPoints,
    response: responsePostBuildings_buildingIdCollectionPoints
  }
}
export interface Buildings_buildingIdCollectionPoints extends BaseRouteType {
  get: IGetBuildings_buildingIdCollectionPoints,
  post: IPostBuildings_buildingIdCollectionPoints
}